import { useLanguage } from '@/contexts/LanguageContext';

const skipText: Record<string, string> = {
  en: 'Skip to main content',
  es: 'Saltar al contenido principal',
  pt: 'Pular para o conteúdo principal',
  fr: 'Aller au contenu principal',
};

const SkipLink = () => {
  const { language } = useLanguage();
  const text = skipText[language] || skipText['en'];
  
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-primary focus:text-primary-foreground focus:rounded-lg focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:font-medium"
      aria-label={text}
    >
      {text}
    </a>
  );
};

export default SkipLink;
